import { UserClaims } from "core/contexts/auth/auth";
import { IncidentSummarySchema } from "../incidentSummary";
import { CommentsContainer, MarkdownContainer, TextContainer } from "../incidentSummary.styled";
import Markdown from 'markdown-to-jsx'
import IncidentComments from "../incidentComments";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { Box, Paper } from "@mui/material";

export interface UbaTableSummaryProps {
    incidentSummary: IncidentSummarySchema | undefined;
    user: UserClaims | null;
}

export const UbaTableSummary = ({
    incidentSummary,
    user
  }: UbaTableSummaryProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    // If incidentSummary is undefined, return a fallback or null to avoid rendering errors
    if (!incidentSummary) {
        return <p>No incident summary available.</p>;  // Or any fallback UI
    }

    return (
        <>
            <span>
                <span className="d-flex flex-row align-content-center mt-3">
                    <p>Employee:</p>
                    <strong className="m-0 ps-2">{incidentSummary.employee_id}</strong>
                </span>
                <span className="d-flex flex-row mt-3">
                    <p className="pe-2">Risk: </p>
                    <MarkdownContainer>
                        <Markdown>
                            {incidentSummary.ai_response_uba_risk_score || ""}
                        </Markdown>
                    </MarkdownContainer>
                </span>
            </span>

            <Box className="d-flex flex-column">
                <MarkdownContainer>
                    <Markdown className="mb-3">
                        {incidentSummary.case_information || ""}
                    </Markdown>
                </MarkdownContainer>
            </Box>

            <CommentsContainer>
                <IncidentComments 
                    t={t} theme={theme} 
                    initialComments={incidentSummary.comments || []} 
                    incidentId={incidentSummary.id || ""} 
                    user={user} 
                />
            </CommentsContainer>

            <TextContainer container spacing={2} className="d-flex flex-column">
                <strong className="mb-3" style={{fontSize: theme.font.large}}>{t("INCIDENTS_PAGE.AI_DISCLAMER_TITLE")}:</strong>
                <p className="word-break"><strong>{t("INCIDENTS_PAGE.PLEASE_NOTE")}: </strong> 
                The information provided here has been generated by AI and, as such, may contain inaccuracies or &#39;hallucinations&#39;. We advise users to verify the accuracy of the information before relying on it for any critical decisions or actions.
                </p>
            </TextContainer>
        </>
    );
};